import './scripts/main';
import './styles/main';



// WEBPACK FOOTER //
// ./module_get_quotes/index.js